"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselConfigDefaultProps = exports.CarouselConfigPropTypes = exports.Carousel = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Layout = require("../Layout");

var _When = _interopRequireDefault(require("../../utils/When"));

var _deviceUtils = require("../../utils/deviceUtils");

var _windowUtils = require("../../utils/windowUtils");

var _CarouselNav = require("./CarouselNav");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StyledCarouselWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "Carousel__StyledCarouselWrapper",
  componentId: "e3nvd6-0"
})({
  '#navControls': {
    button: {
      transition: 'visibility .2s ease-in',
      visibility: function visibility(_ref) {
        var isDesktopView = _ref.isDesktopView;
        return isDesktopView ? 'hidden' : 'visible';
      }
    }
  },
  ':hover': {
    '#navControls': {
      button: {
        visibility: 'visible'
      }
    }
  }
});
var StyledItemsWrapper = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "Carousel__StyledItemsWrapper",
  componentId: "e3nvd6-1"
})((0, _css.default)({
  overflowX: ['auto', 'auto', 'hidden'],
  overflowY: 'hidden'
}));
var StyledCarouselItemWrapper = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "Carousel__StyledCarouselItemWrapper",
  componentId: "e3nvd6-2"
})((0, _css.default)({
  flexGrow: 0,
  flexShrink: 0,
  float: 'left'
}));

var Carousel = function Carousel(_ref2) {
  var hideNavControls = _ref2.hideNavControls,
      itemTemplate = _ref2.itemTemplate,
      items = _ref2.items,
      config = _ref2.config;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      carouselWidth = _useState2[0],
      setCarouselWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isLastItemIntersecting = _useState4[0],
      setLastItemIntersecting = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isDesktopView = _useState6[0],
      setDesktopView = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showNav = _useState8[0],
      setShowNav = _useState8[1];

  var carouselItemsWrapperRef = (0, _react.useRef)({});
  var lastItemObserverRef = (0, _react.useRef)(null);
  var windowWidth = (0, _react.useRef)(window.innerWidth);
  var getWindowSize = (0, _react.useCallback)(function () {
    return (0, _windowUtils.getClientWindowSize)(windowWidth.current);
  }, [windowWidth.current]);

  var getRoundedElementsPerPage = function getRoundedElementsPerPage() {
    return Math.floor(config.navControlsWidth[getWindowSize()] / config.itemsWidth[getWindowSize()]);
  };

  var getNavControlsWidth = function getNavControlsWidth() {
    return Math.floor(config.navControlsWidth[getWindowSize()]);
  };

  var getNavControlsMargin = function getNavControlsMargin() {
    return Math.floor(config.navControlsMargin[getWindowSize()]);
  };

  var getItemsWidth = function getItemsWidth() {
    return config.itemsWidth[getWindowSize()];
  };

  var getItemsMargin = function getItemsMargin() {
    return config.itemsMargin[getWindowSize()];
  };

  var getMarginLeft = function getMarginLeft() {
    return (carouselWidth - getNavControlsWidth()) / 2;
  };

  var getEdgeItemsMarginMobile = function getEdgeItemsMarginMobile() {
    return Object.entries(config.edgeItemsMargin).filter(function (_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
          key = _ref4[0];

      return [_windowUtils.WindowSizes.XS, _windowUtils.WindowSizes.SM].indexOf(key) >= 0;
    }).map(function (_ref5) {
      var _ref6 = (0, _slicedToArray2.default)(_ref5, 2),
          value = _ref6[1];

      return "".concat(value, "px");
    });
  };

  var startLastItemObserver = function startLastItemObserver(node) {
    if (lastItemObserverRef.current) {
      return;
    }

    var observer = new IntersectionObserver(function (_ref7) {
      var _ref8 = (0, _slicedToArray2.default)(_ref7, 1),
          entry = _ref8[0];

      setLastItemIntersecting(entry.isIntersecting);
    }, {
      threshold: '1'
    });
    lastItemObserverRef.current = observer;
    observer.observe(node);
  };

  var getCarouselRef = function getCarouselRef(node) {
    if (node !== null && !carouselWidth) {
      setCarouselWidth(node.getBoundingClientRect().width);
    }
  };

  var getCarouselItemRef = function getCarouselItemRef(node, index) {
    if (node !== null && index === items.length - 1 && !(lastItemObserverRef !== null && lastItemObserverRef !== void 0 && lastItemObserverRef.current)) {
      startLastItemObserver(node);
    }
  };

  var onNavigateToIndex = function onNavigateToIndex(index) {
    var leftOffset = index === 0 ? 0 : index * getItemsWidth() + index * getItemsMargin();
    carouselItemsWrapperRef.current.scrollTo({
      left: leftOffset,
      behavior: 'smooth'
    });
  };

  (0, _react.useLayoutEffect)(function () {
    var listener = function listener() {
      windowWidth.current = window.innerWidth;
      setDesktopView((0, _deviceUtils.isDesktop)());
      setCarouselWidth(0);
    };

    window.addEventListener('resize', listener);
    return function () {
      window.removeEventListener('resize', listener);
    };
  }, []);
  (0, _react.useEffect)(function () {
    setShowNav(!hideNavControls && (items === null || items === void 0 ? void 0 : items.length) > getRoundedElementsPerPage());
  }, [hideNavControls, items, config]);
  (0, _react.useEffect)(function () {
    setDesktopView((0, _deviceUtils.isDesktop)());
    return function () {
      if (lastItemObserverRef.current) {
        lastItemObserverRef.current.disconnect();
      }
    };
  }, []);
  return _react.default.createElement(StyledCarouselWrapper, {
    ref: getCarouselRef,
    marginX: Object.values(config.itemsWrapperPaddingX).map(function (padding) {
      return "-".concat(padding, "px");
    }),
    isDesktopView: isDesktopView
  }, _react.default.createElement(_When.default, {
    condition: showNav
  }, function () {
    return _react.default.createElement(_CarouselNav.CarouselNav, {
      id: "navControls",
      navHeight: config.navHeight,
      navControlsWidth: config.navControlsWidth,
      navControlsColor: config.navControlsColor,
      isLastItemIntersecting: isLastItemIntersecting,
      itemsLength: items.length,
      elementsPerPage: getRoundedElementsPerPage(),
      marginLeft: getMarginLeft(),
      onNavigateToIndex: onNavigateToIndex
    });
  }), (0, _react.useMemo)(function () {
    return _react.default.createElement(StyledItemsWrapper, {
      ref: carouselItemsWrapperRef,
      width: config.carouselWidth,
      paddingY: Object.values(config.itemsWrapperPaddingY).map(function (padding) {
        return "".concat(padding, "px");
      }),
      paddingX: Object.values(config.itemsWrapperPaddingX).map(function (padding) {
        return "".concat(padding, "px");
      })
    }, items.map(function (itemProps, index) {
      return _react.default.createElement(StyledCarouselItemWrapper, {
        key: "dmstk-carousel-item-".concat(index + 1),
        marginLeft: index > 0 ? Object.values(config.itemsMargin).map(function (margin) {
          return "".concat(margin, "px");
        }) : [].concat((0, _toConsumableArray2.default)(getEdgeItemsMarginMobile()), ["".concat(getMarginLeft() + getNavControlsMargin() / 2, "px")]),
        marginRight: index === items.length - 1 ? [].concat((0, _toConsumableArray2.default)(getEdgeItemsMarginMobile()), ["".concat(getMarginLeft() + getNavControlsMargin() / 2, "px")]) : 0,
        ref: function ref(node) {
          return getCarouselItemRef(node, index);
        },
        width: Object.values(config.itemsWidth).map(function (width) {
          return "".concat(width, "px");
        })
      }, itemTemplate(_objectSpread(_objectSpread({}, itemProps), {}, {
        width: '100%'
      })));
    }), "\xA0");
  }, [carouselWidth, config, items]));
};

exports.Carousel = Carousel;

var WindowSizePropTypes = _propTypes.default.shape({
  XS: _propTypes.default.number,
  SM: _propTypes.default.number,
  MD: _propTypes.default.number,
  LG: _propTypes.default.number
});

var WindowSizeDefaultProps = {
  XS: 0,
  SM: 0,
  MD: 0,
  LG: 0
};

var CarouselConfigPropTypes = _propTypes.default.shape({
  carouselWidth: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  navControlsWidth: WindowSizePropTypes,
  navControlsMargin: WindowSizePropTypes,
  navControlsColor: _propTypes.default.oneOf('light', 'dark'),
  navHeight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),
  itemsWrapperPaddingX: WindowSizePropTypes,
  itemsWrapperPaddingY: WindowSizePropTypes,
  itemsMargin: WindowSizePropTypes,
  edgeItemsMargin: WindowSizePropTypes,
  itemsWidth: WindowSizePropTypes
});

exports.CarouselConfigPropTypes = CarouselConfigPropTypes;
var CarouselConfigDefaultProps = {
  carouselWidth: [],
  navControlsWidth: WindowSizeDefaultProps,
  navControlsMargin: WindowSizeDefaultProps,
  navControlsColor: 'dark',
  navHeight: '100%',
  itemsWrapperPaddingX: WindowSizeDefaultProps,
  itemsWrapperPaddingY: WindowSizeDefaultProps,
  itemsMargin: WindowSizeDefaultProps,
  edgeItemsMargin: WindowSizeDefaultProps,
  itemsWidth: WindowSizeDefaultProps
};
exports.CarouselConfigDefaultProps = CarouselConfigDefaultProps;
Carousel.defaultProps = {
  hideNavControls: false,
  config: CarouselConfigDefaultProps
};